<template>
  <div id="app">
    <calculator-form></calculator-form>
    <calculator-result v-if="resultShown"></calculator-result>
  </div>
</template>

<script>
if (!("customElements" in window)) {
  document.querySelector("movingdigital-calculator").innerHTML =
    "<em style='text-align: center; display: block;'>We hebben gedetecteerd dat je een ouder browser gebruikt. Gebruik om een de calculator te gebruiken een moderner, up-to-date browser.</em>";
  throw new Error("De calculator is niet ondersteund in uw browser");
}

import Vue from "vue";
import store from "./store";
import { mapState } from "vuex";

import VueAnime from "vue-animejs";
Vue.use(VueAnime);
Vue.config.productionTip = false;

import CalculatorForm from "./components/CalculatorForm.vue";
import CalculatorResult from "./components/CalculatorResult.vue";

export default {
  store,
  name: "App",
  components: { CalculatorForm, CalculatorResult },
  computed: {
    ...mapState(["resultShown"])
  }
};
</script>

<style lang="scss">
@import "./stylesheets/reset.scss";
@import "./stylesheets/variables.scss";
@import "./stylesheets/utilities.scss";
</style>
